import area11Landing from './Area-11-landing-page.jpg';
import rhlOgidi2 from './rhl-ogidi2.jpg';
import manifest from './hotelImagesManifest.json';

const hotelImageMap = {
  'area-11': area11Landing,
  'area-11-landing-page': area11Landing,
  'area11': area11Landing,
  'guzape': area11Landing,
  'ogidi': rhlOgidi2,
  'rhl-ogidi2': rhlOgidi2,
};

const hotelAliases = {
  'residency-hotel-lekki-osapa-london-lagos': 'chevron',
  'lekki-osapa': 'chevron',
  'osapa': 'chevron',
  'residency-hotel-ajao-estate-lagos': 'ajao',
  'residency-hotel-ajao': 'ajao',
  'residency-ajao': 'ajao',
  'ajao-estate': 'ajao',
};

const categoryAliases = {
  'residency-deluxe': 'deluxe-room',
  'residency-deluxe-room': 'deluxe-room',
  'residency-suite': 'suite',
  'residency-suite-room': 'suite',
};

const normalizeKey = (str = '') =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getHotelFolder = (hotelName) => {
  if (!hotelName) return null;
  const key = normalizeKey(hotelName);
  if (hotelAliases[key]) return hotelAliases[key];
  const aliasKey = Object.keys(hotelAliases).find((alias) =>
    key.includes(alias)
  );
  if (aliasKey) return hotelAliases[aliasKey];
  const folderKeys = Object.keys(manifest).filter((folder) =>
    key.includes(folder)
  );
  if (folderKeys.length === 0) {
    const partial = Object.keys(manifest).find((folder) =>
      folder.includes(key)
    );
    return partial || null;
  }
  return folderKeys.sort((a, b) => a.length - b.length)[0];
};

export const getRoomTypeCategory = (hotelName, roomTypeName) => {
  const folder = getHotelFolder(hotelName);
  if (!folder || !roomTypeName) return null;
  const categories = Object.keys(manifest[folder].categories || {});
  if (categories.length === 0) return null;
  const roomKey = normalizeKey(roomTypeName);
  const roomTokens = new Set(roomKey.split("-").filter(Boolean));

  const exact = categories.find((cat) => cat === roomKey);
  if (exact) return exact;

  const contained = categories
    .filter((cat) => {
      if (cat === roomKey) return false;
      const catTokens = new Set(cat.split("-").filter(Boolean));
      if (catTokens.size === 0) return false;
      const missing = [...catTokens].filter((t) => !roomTokens.has(t));
      if (missing.length > 0) return false;
      const extraInRoom = [...roomTokens].filter(
        (t) => !catTokens.has(t)
      ).length;
      return extraInRoom === 0 || catTokens.size >= 2;
    })
    .sort((a, b) => {
      const aTokens = new Set(a.split("-").filter(Boolean));
      const bTokens = new Set(b.split("-").filter(Boolean));
      const aExact =
        aTokens.size === roomTokens.size &&
        [...roomTokens].every((t) => aTokens.has(t));
      const bExact =
        bTokens.size === roomTokens.size &&
        [...roomTokens].every((t) => bTokens.has(t));
      if (aExact !== bExact) return aExact ? -1 : 1;
      const aMatch = [...aTokens].filter((t) => roomTokens.has(t)).length;
      const bMatch = [...bTokens].filter((t) => roomTokens.has(t)).length;
      if (aMatch !== bMatch) return bMatch - aMatch;
      return a.length - b.length;
    });
  if (contained[0]) return contained[0];

  const partial = categories
    .filter((cat) => {
      if (cat === roomKey) return false;
      const catTokens = new Set(cat.split("-").filter(Boolean));
      return [...roomTokens].every((t) => catTokens.has(t));
    })
    .sort((a, b) => a.length - b.length);
  if (partial[0]) return partial[0];

  const alias = categoryAliases[roomKey];
  if (alias && categories.includes(alias)) return alias;

  return null;
};

export const getHotelImages = (hotelName) => {
  const folder = getHotelFolder(hotelName);
  if (!folder) return null;
  const categories = manifest[folder].categories || {};
  let images = [];
  for (const category of Object.keys(categories)) {
    images = images.concat(categories[category]);
  }
  return images.length > 0 ? images : null;
};

export const getRoomTypeImages = (hotelName, roomTypeName) => {
  const folder = getHotelFolder(hotelName);
  if (!folder) return null;
  const category = getRoomTypeCategory(hotelName, roomTypeName);
  if (!category) return null;
  const images = manifest[folder].categories[category];
  return images && images.length > 0 ? images : null;
};

export const getRoomTypeImage = (hotelName, roomTypeName) => {
  const images = getRoomTypeImages(hotelName, roomTypeName);
  return images ? images[0] : null;
};

export const getHotelImage = (hotelName) => {
  if (!hotelName) return null;
  const folder = getHotelFolder(hotelName);
  if (folder && manifest[folder].cover) return manifest[folder].cover;
  const key = normalizeKey(hotelName);
  if (hotelImageMap[key]) return hotelImageMap[key];
  for (const mapKey of Object.keys(hotelImageMap)) {
    if (key.includes(mapKey)) return hotelImageMap[mapKey];
  }
  return null;
};

export const getHotelCategoryImages = (hotelName, category) => {
  const folder = getHotelFolder(hotelName);
  if (!folder || !category) return null;
  const categories = manifest[folder]?.categories || {};
  const key = normalizeKey(category);
  if (categories[key]) return categories[key];
  const match = Object.keys(categories).find(
    (cat) => cat.includes(key) || key.includes(cat)
  );
  return match ? categories[match] : null;
};